export const CAMPAIGN_CHARACTER_TARGET_MODE_PLAYERS = 'playerCharacters';
export const CAMPAIGN_CHARACTER_TARGET_MODE_TEST = 'testCharacters';
export const CAMPAIGN_CHARACTER_TARGET_MODE_PRACTICE = CAMPAIGN_CHARACTER_TARGET_MODE_TEST;

export const CAMPAIGN_CHARACTER_TARGET_MODES = [
  CAMPAIGN_CHARACTER_TARGET_MODE_PLAYERS,
  CAMPAIGN_CHARACTER_TARGET_MODE_TEST,
];

export const getAvailableCampaignCharacterTargetModes = ({
  includePractice = true,
} = {}) => (
  includePractice
    ? CAMPAIGN_CHARACTER_TARGET_MODES
    : [CAMPAIGN_CHARACTER_TARGET_MODE_PLAYERS]
);

export const getCampaignCharacterKind = (row) => (
  row?.campaignCharacterKind === 'test'
  || row?.campaignCharacterKind === 'sandbox'
  || row?.isTestCharacter === true
  || row?.isSandboxCharacter === true
    ? 'test'
    : 'player'
);

export const isCampaignTestCharacter = (row) => getCampaignCharacterKind(row) === 'test';
export const isLegacyCampaignPracticeCharacter = isCampaignTestCharacter;

export const isCampaignSandboxCharacter = (row) => (
  row?.isSandboxCharacter === true
  || row?.campaignCharacterKind === 'sandbox'
);

export const isRuntimeNpcCharacter = (row) => (
  row?.id === 'dm'
  || row?.charId === 'dm'
  || row?.isNPC === true
  || row?.type === 'npc'
);

export const listCharacterTargetRows = (rowsOrMap, {
  campaignId = null,
  excludeIds = [],
} = {}) => {
  const rows = Array.isArray(rowsOrMap)
    ? rowsOrMap
    : Object.values(rowsOrMap || {});
  const excluded = new Set((excludeIds || []).map((id) => String(id)));
  return rows
    .filter(Boolean)
    .filter((row) => {
      const id = row.id || row.charId;
      if (!id || excluded.has(String(id))) return false;
      if (isRuntimeNpcCharacter(row)) return false;
      if (campaignId && String(row.campaignId || '') !== String(campaignId)) return false;
      return true;
    });
};

export const splitCampaignCharacterTargets = (rowsOrMap, options = {}) => {
  const playerCharacters = [];
  const testCharacters = [];
  for (const row of listCharacterTargetRows(rowsOrMap, options)) {
    if (isCampaignTestCharacter(row)) testCharacters.push(row);
    else playerCharacters.push(row);
  }
  return { playerCharacters, testCharacters };
};

export const getCampaignCharacterTargetsForMode = (
  rowsOrMap,
  mode = CAMPAIGN_CHARACTER_TARGET_MODE_PLAYERS,
  options = {},
) => {
  const buckets = splitCampaignCharacterTargets(rowsOrMap, options);
  return mode === CAMPAIGN_CHARACTER_TARGET_MODE_TEST
    ? buckets.testCharacters
    : buckets.playerCharacters;
};

export const getCampaignCharacterTargetIdsForMode = (
  rowsOrMap,
  mode = CAMPAIGN_CHARACTER_TARGET_MODE_PLAYERS,
  options = {},
) => getCampaignCharacterTargetsForMode(rowsOrMap, mode, options)
  .map((row) => row.id || row.charId)
  .filter(Boolean);

export const pruneTargetIdsForMode = (
  ids,
  rowsOrMap,
  mode = CAMPAIGN_CHARACTER_TARGET_MODE_PLAYERS,
  options = {},
) => {
  const allowed = new Set(getCampaignCharacterTargetIdsForMode(rowsOrMap, mode, options));
  return new Set([...ids].filter((id) => allowed.has(id)));
};

export const getCampaignCharacterTargetModeCopy = (
  mode = CAMPAIGN_CHARACTER_TARGET_MODE_PLAYERS,
) => (
  mode === CAMPAIGN_CHARACTER_TARGET_MODE_TEST
    ? {
        label: 'Saved practice characters',
        helper: 'Legacy setup/practice rows only. Real player characters will not be changed.',
        ctaNoun: 'saved practice characters',
      }
    : {
        label: 'Player characters',
        helper: 'Live table changes. Saved practice characters are excluded.',
        ctaNoun: 'player characters',
      }
);
